import React, { useState, useEffect } from 'react';
import './../css/Login.css'
import { Link, useNavigate } from 'react-router-dom';
import { auth, db } from './../../firebase/firebaseConfig';
import { createUserWithEmailAndPassword, sendEmailVerification, updateProfile } from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore";
import PageTitle from '../includes/PageTitle';
import Layout from './Layout';

export default function SignUp() {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserRole = async () => {
      try {
        const user = auth.currentUser;
        if (user) {
          const userDoc = await getDoc(doc(db, "users", user.uid));
          if (userDoc.exists()) {
            setUserRole(userDoc.data().role);
          }
        }
      } catch (error) {
        console.error('Error fetching user role:', error);
      }
    };

    fetchUserRole();
  }, []);

  const validateName = (name) => {
    return /^[A-Za-z]+$/.test(name);
  };

  const validatePassword = (password) => {
    return /^(?=.*\d).{8,12}$/.test(password);
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    if (id === 'firstName') setFirstName(value);
    if (id === 'lastName') setLastName(value);
    if (id === 'email') setEmail(value);
    if (id === 'password') setPassword(value);
  };

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (!validateName(firstName)) {
        throw new Error('First name should only contain letters.');
      }
      if (!validateName(lastName)) {
        throw new Error('Last name should only contain letters.');
      }
      if (!validatePassword(password)) {
        throw new Error('Password must be 8 to 12 characters long and contain at least one number.');
      }

      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      console.log('User registered:', user);

      // Send email verification
      await sendEmailVerification(user);

      // Update user profile with displayName
      await updateProfile(user, {
        displayName: `${firstName} ${lastName}`
      });

      // Add user details to Firestore including role
      await setDoc(doc(db, "users", user.uid), {
        firstName: firstName,
        lastName: lastName,
        email: email,
        displayName: `${firstName} ${lastName}`,
        role: "admin"
      });

      navigate('/verify-email');
    } catch (error) {
      let errorMessage = 'An error occurred. Please try again.';
      switch (error.code) {
        case 'auth/email-already-in-use':
          errorMessage = 'Email address is already in use.';
          break;
        case 'auth/invalid-email':
          errorMessage = 'Invalid email address format.';
          break;
        case 'auth/weak-password':
          errorMessage = 'Password is too weak. Please choose a stronger password.';
          break;
        default:
          errorMessage = error.message || errorMessage;
          break;
      }
      setErrorMessage(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <PageTitle title="Admin Sign Up - ALMOSTINVISIBLE" />
      <Layout>
      <h1 className="unbounded">Sign Up An Admin</h1>
        <div style={{ marginTop: "5vh", display: "flex", justifyContent: "center" }}>
            <form className="form" onSubmit={handleSubmit}>           
            {errorMessage && (
                <div className="alert alert-danger alert-dismissible fade show mt-3" role="alert">
                {errorMessage}
                <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
            )}
            <div>
                <div className="flex-column">
                <label className='nunito-2'>Firstname*</label>
                </div>
                <div className="inputForm">
                <input
                    type="text"
                    className="input"
                    value={firstName}
                    onChange={handleInputChange}
                    id="firstName"
                    placeholder="Enter your firstname"
                    required
                />
                </div>
            </div>
            <div>
                <div className="flex-column">
                <label>Lastname*</label>
                </div>
                <div className="inputForm">
                <input
                    type="text"
                    className="input"
                    id="lastName"
                    value={lastName}
                    onChange={handleInputChange}
                    placeholder="Enter your lastname"
                    required
                />
                </div>
            </div>
            <div>
                <div className="flex-column">
                <label>Email*</label>
                </div>
                <div className="inputForm">
                <input
                    type="email"
                    className="input"
                    value={email}
                    id="email"
                    onChange={handleInputChange}
                    placeholder="Enter your email"
                    required
                />
                </div>
            </div>
            <div>
                <div className="flex-column">
                <label>Password*</label>
                </div>
                <div className="inputForm">
                <input
                    type={passwordVisible ? 'text' : 'password'}
                    className="input"
                    id="password"
                    value={password}
                    onChange={handleInputChange}
                    placeholder="Enter your password"
                    required
                />
                <svg viewBox="0 0 576 512" height="1em" style={{ cursor: "pointer" }} onClick={togglePasswordVisibility} xmlns="http://www.w3.org/2000/svg">
                    <path d="M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z" />
                </svg>
                </div>
            </div>
            <div className="d-flex justify-content-center mt-3">
                <button type="submit" className="black-button position-relative" disabled={loading}>
                Sign Up
                {loading && (
                    <div className="spinner-border text-light ms-2 spinner-border-sm" role="status">
                    <span className="visually-hidden">Loading...</span>
                    </div>
                )}
                </button>
            </div>
            </form>
        </div>
      </Layout>
    </>
  );
}
